module.exports = __webpack_public_path__ + "static/Garden1-2ab72d85b97122d7dda9172f45e8f71e.jpeg";